<template>
	<div class="glass-card" :style="computedStyle" v-bind="$attrs">
		<slot />
	</div>
</template>

<script setup>
	import { computed } from "vue"

	const props = defineProps({
		background: { type: String, default: "rgba(255, 255, 255, 0.08)" },
		borderColor: { type: String, default: "rgba(255, 255, 255, 0.2)" },
		blur: { type: String, default: "16px" },
		saturate: { type: String, default: "140%" },
	})

	const computedStyle = computed(() => ({
		background: props.background,
		backdropFilter: `blur(${props.blur}) saturate(${props.saturate})`,
		WebkitBackdropFilter: `blur(${props.blur}) saturate(${props.saturate})`,
		borderColor: props.borderColor,
	}))
</script>

<style scoped>
	.glass-card {
		border-radius: 1.5rem; /* ~ rounded-3xl */
		border-width: 1px;
		border-style: solid;
	}
</style>
